import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

const SitePermissionsPageRouteComponent = LoadableAfterPaint({
	loader: async () =>
		import(
			/* webpackChunkName: "loadable-SitePermissionsPageRouteComponent" */ './SitePermissionsPageRouteComponent.tsx'
		),
});

export const SitePermissionsPageRoute = () => <SitePermissionsPageRouteComponent />;

SitePermissionsPageRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: {
			name: 'sitePermissionsScreen',
		},
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
